const trackViewItem = (product) => {
  const productData = {
    currency: product.currency,
    value: Number(product.featured_price),
    items: [
      {
        item_id: String(product.id),
        item_name: product.title,
        price: Number(product.featured_price),
        quantity: 1,
      },
    ],
  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({ ecommerce: null });

  window.dataLayer.push({
    event: "view_item",
    ecommerce: productData
  });
};

export {trackViewItem}